module.exports = __webpack_public_path__ + "img/attachment-pdf.4b33299c.svg";